import React from 'react';
import { QRCodeSVG } from 'qrcode.react';
import './LeadershipTeam.css';

const leaders = [
  {
    name: 'Kishor Das',
    role: 'Co-founder',
    image: '/images/Kishor.png',
    linkedIn: 'https://www.linkedin.com/in/kishor-das-92139b7/',
    bio: '30+ years of data and AI strategy, governance, and regulatory experience, bringing technology, transformation, and commercial leadership.'
  },
  {
    name: 'Munish Dhall',
    role: 'Co-founder',
    image: '/images/munish.jpg',
    linkedIn: 'https://www.linkedin.com/in/munish-dhall-512bb83/',
    bio: '25+ years of technology and transformation experience, with architecture, design, and delivery expertise in scalable enterprise-grade solutions.'
  },
  {
    name: 'Dr Amit Wason',
    role: 'Co-founder',
    image: '/images/Amit.png',
    linkedIn: 'https://www.linkedin.com/in/prof-dr-amit-wason-803b0a11/',
    bio: '25+ years in academia and institutional leadership, with deep understanding of real educational needs, institutional challenges, and academic credibility.'
  },
  {
    name: 'Kofil Ali',
    role: 'Board Member',
    image: '/images/Kofil.png',
    linkedIn: 'https://www.linkedin.com/in/kofil-ali-a6823215/',
    bio: 'Technology leader with ~25 years of experience in financial services, strong networking, partnerships, and alliance management expertise.'
  },
  {
    name: 'Ravi Pandey',
    role: 'Board Member',
    image: '/images/Ravi.jpg',
    linkedIn: 'https://www.linkedin.com/in/pandeyravi/',
    bio: 'Experienced business leader with a strong track record in growing technology businesses, bringing the strategic and commercial discipline required to scale.'
  }
];

const LeadershipTeam = () => (
  <section className="leadership-section" aria-labelledby="leadership-heading">
    <div className="leadership-container">
      <header className="leadership-heading">
        <p className="leadership-eyebrow">THE PEOPLE BEHIND AIVION</p>
        <h2 id="leadership-heading">Leadership Team</h2>
        <p>Experienced leaders in data, AI, technology, education, and business transformation.</p>
      </header>

      <div className="leadership-grid">
        {leaders.map((leader) => (
          <article className="leader-card" key={leader.name}>
            <div className="leader-card__identity">
              <img className="leader-card__portrait" src={leader.image} alt={`Portrait of ${leader.name}`} />
              <div>
                <h3>{leader.name}</h3>
                <p className="leader-card__role">{leader.role}</p>
              </div>
            </div>
            <p className="leader-card__bio">{leader.bio}</p>
            <a
              className="leader-card__linkedin"
              href={leader.linkedIn}
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`Scan the QR code or open ${leader.name}'s LinkedIn profile`}
            >
              <QRCodeSVG
                value={leader.linkedIn}
                size={76}
                level="M"
                includeMargin
                title={`LinkedIn QR code for ${leader.name}`}
              />
              <span><strong>Connect on LinkedIn</strong><small>Scan or click the QR code</small></span>
            </a>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default LeadershipTeam;
